import { __assign } from "tslib";
import * as React from 'react';
import { CnIcon } from "../cn-icon";
import { CnPopover } from "../cn-popover";
import './cn-card-title.scss';
export var CardTitle = function (props) {
    var title = props.title, desc = props.desc, icon = props.icon, action = props.action;
    var iconProps = React.useMemo(function () {
        if (icon) {
            if (typeof icon === 'string') {
                return {
                    type: icon,
                };
            }
            return icon;
        }
        return null;
    }, [icon]);
    return (React.createElement("div", { className: "cn-ui-m-card-title" },
        React.createElement("div", { className: "cn-ui-m-card-title-header" },
            iconProps && React.createElement(CnIcon, __assign({ className: "icon" }, iconProps)),
            React.createElement("div", { className: "title" }, title),
            desc && (React.createElement(CnPopover, { content: desc, trigger: "click" },
                React.createElement(CnIcon, { type: "icon-help", className: "desc" })))),
        React.createElement("div", { className: "cn-ui-m-card-title-footer" }, action)));
};
